import React, { useState } from "react";
import { useParams } from "react-router-dom";
import AppCustomers from "@/components/customers/AppCustomers";

const AppCustomersPage = () => {
  const { appId } = useParams();
  const [applicationName, setApplicationName] = useState<string>("");

  const handleApplicationLoaded = (name: string) => {
    setApplicationName(name);
  };

  return (
    <>
      <AppCustomers
        ApplicationId={Number(appId)}
        ShowOnlyNewAppCustomerPanel={false}
        breadcrumbTitle="Application | Customers"
        breadcrumbSubtitle={
          applicationName ? (
            <>
              Manage customers for application{" "}
              <strong>{applicationName}</strong>
            </>
          ) : (
            "Manage customers for this application"
          )
        }
        onApplicationLoaded={handleApplicationLoaded}
      />
    </>
  );
};

export default AppCustomersPage;
